/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Customer_Current_DebtInputs */

const vi_order_customer_current_debt = /** @type {(inputs: Order_Customer_Current_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách đang nợ`)
};

/**

* @param {Order_Customer_Current_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_customer_current_debt = /** @type {((inputs?: Order_Customer_Current_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Customer_Current_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_customer_current_debt(inputs)
});